<style lang="stylus">

#app,input,button
	font-family 'Krub', Helvetica, Arial, sans-serif

#app
	-webkit-font-smoothing antialiased
	-moz-osx-font-smoothing grayscale
	
	height 100vh
body
	margin 0
	padding 0
	box-sizing border-box

*
	box-sizing border-box

button 
	border 0 
	background #222
	color #fff
	padding 8px 16px

a
	text-decoration none

</style>



<template>
	<div id="app">
		<Breath />
	</div>
</template>

<script>
import Breath from "./components/Breath.vue";

export default {
	name: "app",
	components: {
		Breath
	}
};
</script>
